var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartureTimeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 33",
    style: {
      enableBackground: "new 0 0 32 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000122703609144472236640000003119996009939998626_);}\n\t.st1{fill:#AF1C2D;stroke:#AF1C2D;}\n\t.st2{fill:none;stroke:#AF1C2D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155859036762347624070000009686851652938434477_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155859036762347624070000009686851652938434477_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,16.8l3,4C8.7,21,9,21.1,9.2,21l8-3.2l10.3-4.1c0.8-0.3,1.6-0.9,1.4-1.8c-0.1-0.7-0.6-1.1-1.2-1.3 c-0.5-0.2-1.1-0.1-1.6,0.1l-5.4,2c-0.2,0.1-0.3,0-0.5-0.1l-8.5-6.3c-0.1-0.1-0.3-0.1-0.5-0.1L9.8,6.8C9.5,6.9,9.4,7.3,9.6,7.5 l5.1,6.8c0.2,0.3,0.1,0.6-0.2,0.8l-4.9,1.9c-0.2,0.1-0.3,0-0.5,0l-2-1.3c-0.1-0.1-0.3-0.1-0.5,0l-0.9,0.3 C5.5,16.2,5.4,16.6,5.6,16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.8,26.8h22.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartureTimeRed);
export default __webpack_public_path__ + "static/media/departure-time-red.80ae65a99c438e4cc5faa15ede88bed1.svg";
export { ForwardRef as ReactComponent };